const Footer = () => {
    const styles = {
      footer: {
        backgroundColor: '#1f2937',
        color: '#ffffff',
        padding: '60px 40px 30px',
      },
      container: {
        maxWidth: '1400px',
        margin: '0 auto',
      },
      topSection: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '40px',
        paddingBottom: '40px',
        borderBottom: '1px solid #374151',
      },
      column: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      },
      logo: {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#667eea',
        marginBottom: '12px',
      },
      description: {
        fontSize: '14px',
        color: '#9ca3af',
        lineHeight: '1.6',
      },
      columnTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '8px',
        color: '#ffffff',
      },
      link: {
        fontSize: '14px',
        color: '#9ca3af',
        textDecoration: 'none',
        transition: 'color 0.3s ease',
        cursor: 'pointer',
      },
      socialIcons: {
        display: 'flex',
        gap: '16px',
        marginTop: '8px',
      },
      socialIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: '#374151',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        fontSize: '18px',
      },
      bottomSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '30px',
        flexWrap: 'wrap',
        gap: '20px',
      },
      copyright: {
        fontSize: '14px',
        color: '#9ca3af',
      },
      bottomLinks: {
        display: 'flex',
        gap: '24px',
        flexWrap: 'wrap',
      },
      contactInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '12px',
      },
      contactIcon: {
        fontSize: '20px',
      },
      contactText: {
        fontSize: '14px',
        color: '#9ca3af',
      },
    };
  
    const quickLinks = [
      'Home',
      'About Us',
      'Services',
      'Technology',
      'Portfolio',
      'Contact'
    ];
  
    const services = [
      'Web Development',
      'Mobile Apps',
      'Custom Software',
      'DPC / EMM Solutions',
      'Cloud Services',
      'Consulting'
    ];
  
    return (
      <footer style={styles.footer}>
        <div style={styles.container}>
          {/* Top Section */}
          <div style={styles.topSection}>
            {/* Company Info */}
            <div style={styles.column}>
              <div style={styles.logo}>Tracklio Hub</div>
              <p style={styles.description}>
                Building innovative software solutions for modern businesses. 
                We transform ideas into powerful digital products.
              </p>
              <div style={styles.socialIcons}>
                <div
                  style={styles.socialIcon}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#667eea';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#374151';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>f</span>
                </div>
                <div
                  style={styles.socialIcon}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#667eea';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#374151';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>𝕏</span>
                </div>
                <div
                  style={styles.socialIcon}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#667eea';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#374151';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>in</span>
                </div>
                <div
                  style={styles.socialIcon}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#667eea';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#374151';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>📷</span>
                </div>
              </div>
            </div>
  
            {/* Quick Links */}
            <div style={styles.column}>
              <h3 style={styles.columnTitle}>Quick Links</h3>
              {quickLinks.map((link, index) => (
                <a
                  key={index}
                  href={`#${link.toLowerCase().replace(' ', '-')}`}
                  style={styles.link}
                  onMouseEnter={(e) => e.target.style.color = '#667eea'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  {link}
                </a>
              ))}
            </div>
  
            {/* Services */}
            <div style={styles.column}>
              <h3 style={styles.columnTitle}>Services</h3>
              {services.map((service, index) => (
                <a
                  key={index}
                  href="#services"
                  style={styles.link}
                  onMouseEnter={(e) => e.target.style.color = '#667eea'}
                  onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
                >
                  {service}
                </a>
              ))}
            </div>
  
            {/* Contact Info */}
            <div style={styles.column}>
              <h3 style={styles.columnTitle}>Contact Us</h3>
              <div style={styles.contactInfo}>
                <span style={styles.contactIcon}>📧</span>
                <span style={styles.contactText}>support@trackliohub.com</span>
              </div>
              <div style={styles.contactInfo}>
                <span style={styles.contactIcon}>📞</span>
                <span style={styles.contactText}>+91 (870) 967-8738</span>
              </div>
              <div style={styles.contactInfo}>
                <span style={styles.contactIcon}>📍</span>
                <span style={styles.contactText}>
                  Bijwasan Flayover, Delhi, 110061
                </span>
              </div>
              <div style={styles.contactInfo}>
                <span style={styles.contactIcon}>🕐</span>
                <span style={styles.contactText}>Mon - Fri: 9:00 AM - 6:00 PM</span>
              </div>
            </div>
          </div>
  
          {/* Bottom Section */}
          <div style={styles.bottomSection}>
            <div style={styles.copyright}>
              © {new Date().getFullYear()} Tracklio. All rights reserved.
            </div>
            <div style={styles.bottomLinks}>
              <a
                href="privacy-policy"
                style={styles.link}
                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
              >
                Privacy Policy
              </a>
              <a
                href="terms-of-service"
                style={styles.link}
                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
              >
                Terms of Service
              </a>
              <a
                href="refund-policy"
                style={styles.link}
                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
              >
                Refund Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  };
  
  export default Footer;